module.exports = __webpack_public_path__ + "img/aParty_111523_G.8214d6a9.jpg";